import Chevron from 'src/app/icons/Monospaced/Chevron/Chevron';
import Stack from 'atoms/Layout/Stack/Stack';
import styled from 'styled-components';
import { cssVar } from 'styles/helper';

export const ChevronIcon = styled(Chevron)`
  transition: transform 0.3s ease-in-out;
`;

export const SideNavLinkContainer = styled(Stack)`
  width: 100%;

  .sidenav-menu-link {
    width: 100%;
    color: ${cssVar('text-primary')};
    justify-content: space-between;

    &:focus {
      box-shadow: none;
    }
  }
`;
